'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import type { Reference } from '@eliadmin/core/src/api/references/references-types';

import { HtmlRenderer } from '@eliadmin/core/src/components/ui/project-html-renderer';

export function ReferenceCard({ reference }: { reference: Reference }) {
  return (
    <Link
      prefetch={false}
      href={reference.slug}
      className="col-span-1 flex w-full flex-col items-start justify-start overflow-hidden rounded-[16px]"
    >
      <Image
        src={reference?.image?.url ?? '/images/placeholder.png'}
        alt={resolveImageAlt(reference?.image, reference?.name)}
        width={0}
        height={0}
        className="h-[204px] w-full object-cover object-center sm:h-[240px]"
        sizes="(max-width: 640px) 90vw, (max-width: 768px) 50vw, 30vw"
      />
      <div className="flex w-full flex-col items-start justify-start gap-2 bg-white p-4 md:gap-4">
        <h3 className="line-clamp-2 h-12 text-base font-bold text-foreground md:h-14 md:text-lg">
          {reference.name}
        </h3>
        <HtmlRenderer
          html={reference.description}
          variant="description"
          color="light-gray"
          className="ea-reference-card__description line-clamp-3 w-full"
        />
        <strong className="text-sm font-bold text-foreground sm:text-base">
          {reference.firstname} {reference.surname}
        </strong>
      </div>
    </Link>
  );
}
